export enum SeriesFilterEnum {
  PREV_TOTAL_CONSUMPTION = 'PREV_TOTAL_CONSUMPTION',
  TOTAL_CONSUMPTION = 'TOTAL_CONSUMPTION',
  DAY_NIGHT = 'DAY_NIGHT',
  LOCAL_NETWORK_CONSUMPTION = 'LOCAL_NETWORK_CONSUMPTION',
  PREV_TOTAL_INJECTION = 'PREV_TOTAL_INJECTION',
  TOTAL_INJECTION = 'TOTAL_INJECTION',
  LOCAL_NETWORK_INJECTION = 'LOCAL_NETWORK_INJECTION',
}
